<div class="hold-transition sidebar-mini layout-navbar-fixed layout-footer-fixed">
  <div class="wrapper">
    <app-header></app-header>
    <app-sidebar [page]="'dealslip'" [subPage]="'cross-exchange-rate'"></app-sidebar>

    <div class="content-wrapper cross-rate-page">
      <section class="content-header">
        <div class="container-fluid">
          <div class="page-heading">
            <div><span class="eyebrow">DEALSLIP TOOLS</span><h1>Cross Exchange Rate</h1><p>Calculate the implied exchange rate between two currencies using a shared reference currency.</p></div>
            <button type="button" class="btn btn-outline-secondary" (click)="reset()"><i class="fas fa-redo-alt mr-2"></i>Clear</button>
          </div>
        </div>
      </section>

      <section class="content">
        <div class="container-fluid">
          <div class="calculator-shell">
            <form [formGroup]="calculatorForm" class="rate-form">
              <div class="section-title"><span>1</span><div><h2>Choose currencies</h2><p>A and B are the currencies being compared. C is their common currency.</p></div></div>
              <div class="currency-grid">
                <label>Currency A<select formControlName="currencyA"><option value="">Select currency</option><option *ngFor="let currency of currencies" [value]="currency.code">{{ currency.code }} — {{ currency.name }}</option></select></label>
                <label>Currency B<select formControlName="currencyB"><option value="">Select currency</option><option *ngFor="let currency of currencies" [value]="currency.code">{{ currency.code }} — {{ currency.name }}</option></select></label>
                <label>Common currency C<select formControlName="commonCurrency"><option value="">Select currency</option><option *ngFor="let currency of currencies" [value]="currency.code">{{ currency.code }} — {{ currency.name }}</option></select></label>
              </div>
              <div class="validation-note" *ngIf="duplicateCurrencies"><i class="fas fa-exclamation-circle"></i> Select three different currencies.</div>

              <div class="section-title rate-section"><span>2</span><div><h2>Enter known rates</h2><p>Enter both quotations against the same common currency.</p></div></div>
              <div class="known-rates">
                <div class="rate-card">
                  <div class="pair-label">First currency pair</div>
                  <label>Exchange rate {{ calculatorForm.value.currencyA || 'A' }}/{{ calculatorForm.value.commonCurrency || 'C' }}</label>
                  <div class="number-field"><input type="number" min="0" step="0.000001" formControlName="rateAC" placeholder="0.000000"><span>{{ calculatorForm.value.commonCurrency || 'C' }}</span></div>
                  <small *ngIf="inverseAC">Inverse {{ calculatorForm.value.commonCurrency || 'C' }}/{{ calculatorForm.value.currencyA || 'A' }} = {{ inverseAC | number:'1.4-8' }}</small>
                </div>
                <div class="rate-card">
                  <div class="pair-label">Second currency pair</div>
                  <label>Exchange rate {{ calculatorForm.value.currencyB || 'B' }}/{{ calculatorForm.value.commonCurrency || 'C' }}</label>
                  <div class="number-field"><input type="number" min="0" step="0.000001" formControlName="rateBC" placeholder="0.000000"><span>{{ calculatorForm.value.commonCurrency || 'C' }}</span></div>
                  <small *ngIf="inverseBC">Inverse {{ calculatorForm.value.commonCurrency || 'C' }}/{{ calculatorForm.value.currencyB || 'B' }} = {{ inverseBC | number:'1.4-8' }}</small>
                </div>
              </div>
            </form>

            <aside class="result-panel" [class.ready]="crossAB > 0 && !duplicateCurrencies">
              <div class="result-icon"><i class="fas fa-exchange-alt"></i></div>
              <span class="result-kicker">CROSS RATE</span>
              <h2>{{ calculatorForm.value.currencyA || 'A' }}/{{ calculatorForm.value.currencyB || 'B' }}</h2>
              <strong>{{ crossAB > 0 && !duplicateCurrencies ? (crossAB | number:'1.4-8') : '—' }}</strong>
              <p>1 {{ calculatorForm.value.currencyA || 'A' }} equals {{ crossAB > 0 && !duplicateCurrencies ? (crossAB | number:'1.4-8') : '—' }} {{ calculatorForm.value.currencyB || 'B' }}</p>
              <div class="inverse-result"><span>Inverse rate</span><b>{{ calculatorForm.value.currencyB || 'B' }}/{{ calculatorForm.value.currencyA || 'A' }} {{ crossBA > 0 && !duplicateCurrencies ? (crossBA | number:'1.4-8') : '—' }}</b></div>
              <div class="formula"><span>Formula</span><code>({{ calculatorForm.value.currencyA || 'A' }}/{{ calculatorForm.value.commonCurrency || 'C' }}) ÷ ({{ calculatorForm.value.currencyB || 'B' }}/{{ calculatorForm.value.commonCurrency || 'C' }})</code></div>
            </aside>
          </div>
        </div>
      </section>
    </div>
    <app-footer></app-footer>
  </div>
</div>
